import type { FootnotesState } from '#shared/utils/html/footnotes'
import { getFootnoteIdFromEvent } from '#shared/utils/html/footnotes'

export function useFootnoteClickHandler({ footnotes, open, close }: {
  footnotes: MaybeRefOrGetter<FootnotesState | undefined>
  open: (id: string) => void
  close: (id: string) => void
}) {
  function handleClick(event: Event) {
    const footnoteId = getFootnoteIdFromEvent(event)
    if (!footnoteId) {
      return
    }

    const state = toValue(footnotes)?.[footnoteId]
    if (!state) {
      return
    }

    if (state.open) {
      close(footnoteId)
    }
    else {
      open(footnoteId)
    }
  }

  return { handleClick }
}
